const CantHelpFallingInLove = [
	'[Verse 1]',
	'Wise men say, only fools rush in',
	"But I can't help falling in love with you",
	'',
	'Shall I stay, would it be a sin?',
	"If I can't help falling in love with you",
	'',
	'[Chorus]',
	'Like a river flows surely to the sea',
	'Darling so it goes',
	'Some things are meant to be',
	'',
	'[Verse 2]',
	'Take my hand, take my whole life too',
	"For I can't help falling in love with you",
	'',
	'[Chorus]',
	'Like a river flows surely to the sea',
	'Darling so it goes',
	'Some things are meant to be',
	'',
	'[Verse 3]',
	'Take my hand, take my whole life too',
	"For I can't help falling in love with you",
	"For I can't help falling in love with you",
];

export default CantHelpFallingInLove;
